// extracted by mini-css-extract-plugin
module.exports = {"coinShop":"CoinShop_coinShop__3l71g"};